import a from "../../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import p from "../../../@babel/runtime/helpers/esm/objectWithoutProperties.mjs";
import * as f from "react";
import v from "../../../rc-util/es/Children/toArray.mjs";
var s = ["children", "value"], d = ["children"];
function _(l) {
  var o = l, r = o.key, n = o.props, t = n.children, i = n.value, e = p(n, s);
  return a({
    key: r,
    value: i !== void 0 ? i : r,
    children: t
  }, e);
}
function h(l) {
  var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return v(l).map(function(r, n) {
    if (!/* @__PURE__ */ f.isValidElement(r) || !r.type)
      return null;
    var t = r, i = t.type.isSelectOptGroup, e = t.key, u = t.props, c = u.children, m = p(u, d);
    return o || !i ? _(r) : a(a({
      key: "__RC_SELECT_GRP__".concat(e === null ? n : e, "__"),
      label: e
    }, m), {}, {
      options: h(c)
    });
  }).filter(function(r) {
    return r;
  });
}
export {
  h as convertChildrenToData
};
//# sourceMappingURL=legacyUtil.mjs.map
